<div class="modal-header">
  <h5 class="modal-title d-flex gap-2 align-items-center">
    <i class="fal fa-search"></i>
    <ng-container i18n>Search Results</ng-container>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body p-0 m-0">
  <ng-container [ngSwitch]="data.type">
    <app-booking-results-table *ngSwitchCase="dataTypes.Booking" [results]="data.results"></app-booking-results-table>
    <app-invoice-results-table *ngSwitchCase="dataTypes.Invoice" [results]="data.results"></app-invoice-results-table>
    <app-guest-results-table *ngSwitchCase="dataTypes.Guest" [results]="data.results"></app-guest-results-table>
    <app-hold-results-table *ngSwitchCase="dataTypes.Hold" [results]="data.results"></app-hold-results-table>
    <app-rental-results-table *ngSwitchCase="dataTypes.Rental" [results]="data.results"></app-rental-results-table>
    <div *ngSwitchDefault>No results to display.</div>
  </ng-container>
</div>
